import { PropsWithChildren } from 'react';

import { PropsWithTestAttribute } from 'types/testAttribute';

import { LinkStyled } from './Link.styles';
import { LinkProps } from './types';

/**
 * Link component.
 */
export const Link = ({
  href,
  target,
  disabled,
  children,
  className,
  mode = 'default',
  datax,
  onClick,
}: LinkProps & PropsWithChildren & PropsWithTestAttribute) => (
  <LinkStyled
    className={className}
    datax={datax}
    disabled={disabled}
    href={href}
    mode={mode}
    target={target}
    onClick={!disabled ? onClick : undefined}
  >
    {children}
  </LinkStyled>
);
